import { createTheme } from '@mui/material/styles';
import { getPalette } from './palette';

// Builds the MUI theme for a given color mode. Consumed by main.jsx via ColorModeContext.
export const buildTheme = (mode = 'light') =>
  createTheme({
    palette: getPalette(mode),
    shape: { borderRadius: 10 },
    typography: {
      fontFamily: ['Inter', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
      h4: { fontWeight: 700 },
      h5: { fontWeight: 700 },
      h6: { fontWeight: 600 },
      button: { textTransform: 'none', fontWeight: 600 },
    },
    components: {
      MuiButton: { defaultProps: { disableElevation: true } },
      MuiCard: {
        styleOverrides: {
          root: { borderRadius: 12, border: '1px solid rgba(145,158,171,0.16)' },
        },
        defaultProps: { elevation: 0 },
      },
      MuiPaper: { defaultProps: { elevation: 0 } },
      MuiAppBar: { defaultProps: { elevation: 0, color: 'inherit' } },
      MuiTableCell: { styleOverrides: { head: { fontWeight: 700 } } },
    },
  });

export default buildTheme;
